import React, { Component } from 'react';
import { Button } from 'reactstrap';


export class ProgramTitle extends Component {
    saveFav = () => {
        this.props.saveFav(this.props.program.id);
    }

    render() {
        let program = this.props.program;
        let tags = [];
        if (program.tags) {
            tags = program.tags.map((item, index) => {
                return <span key={index} className="badge badge-pill badge-info ml-1">{item}</span>
            });
        }

        let buttonImg;
        let favButton;
        // only a member can favorite a program
        if (this.props.logInMember) {
            if (this.props.fav === undefined) {
                buttonImg = "../img/white-fav.png";
            } else if (this.props.fav.indexOf(this.props.program.id) > -1) {
                buttonImg = "../img/white-fav-after.png";
            } else {
                buttonImg = "../img/white-fav.png"
            }
            favButton = <div className="m-3 center"><Button onClick={this.saveFav} color="success" size="sm" className="mr-1"><img className="d-inline-block align-bottom" src={buttonImg} alt="Save" /> Save</Button></div>;
        } else {
            favButton = "";
        }

        return (
            <section id="program-title">
                <div className="pt-5 pr-5 pl-5 mt-4">
                    <h1 id="program-title-name" className="title-bd display-4 mb-3">{program.altText}</h1>
                    <div id="tags" className="mb-5">
                        {tags}
                    </div>
                    <div className="mt-2 p-3">
                        <p className="body-lt font-md">{program.description}</p>
                    </div>
                    {favButton}
                </div>
            </section>
        );
    }
}